import { DefaultGroupFormatter } from "../../../Formatters/DefaultGroupFormatter";
import { IStationValueFormatter } from "../../../Formatters/IStationValueFormatter";
import { WmoToMetarWeatherFormatter } from "../../../Formatters/WmoToMetarWeatherFormatter";
import { MainSite, DisplayTimeType } from "../../../MainSite";
import { Station } from "../../../Model/Station";
import { ParameterGroupInfoSet } from "../../../ParameterGroupInfoSet";

interface Props {
    mainSite: MainSite,
    station: Station,
    parameterGroupBlock: any
}

export function TableTimeCell(props: Props): React.JSX.Element {

    // Assume that the timestamp of the first element in the parameterGroupBlock is valid for all elements.
    // This _should_ be the case. 
    const parameterGroup = props.parameterGroupBlock[0];

    let valueFormatter: IStationValueFormatter = new DefaultGroupFormatter(ParameterGroupInfoSet[parameterGroup.Id]);

    // TODO: Check what's up with this and implement for TableValueCell as well.
    if (parameterGroup.Id === ParameterGroupInfoSet.PresentWeather.Id) {
        valueFormatter = new WmoToMetarWeatherFormatter();
    }
        
    let valueObject = valueFormatter.format(
            props.mainSite.liveDataManager.latestData.Stations[props.station.Id], 
            props.mainSite.selectedWarningRules
        );

    let mostRecentTimestamp: number = valueObject.Timestamp;

    const timeNow = moment().utc().valueOf();

    const timeSinceLastData = mostRecentTimestamp ? (timeNow - mostRecentTimestamp) / 1000 / 60 / 60 : mostRecentTimestamp; // [ms] to [h]

    // TODO: SHOULD NOT BE HARD-CODED. Should come from the data. When provided.
    const isTimestampValid = mostRecentTimestamp ? timeSinceLastData < 24 : null;

    let displayedTime: string;

    // TODO: does null correspond to expired??
    //if (mostRecentTimestamp != null && isTimestampValid) {
    if (isTimestampValid) {
        switch (props.mainSite.displayTimeType) {
            case DisplayTimeType.UTC:
                displayedTime = moment.utc(mostRecentTimestamp).format("HH:mm").toString();
                break;
            case DisplayTimeType.PcTime:
                displayedTime = moment(moment.utc(mostRecentTimestamp)).tz(moment.tz.guess()).format("HH:mm");
                break;
            case DisplayTimeType.StationRegionTime:
                displayedTime = moment(moment.utc(mostRecentTimestamp)).tz(props.station.TimeZone).format("HH:mm");
                break;
            default:
                // No action taken
                break;

            }
        }

    return (
        <td
            className="midi_tablePage_main_table_obstime midi_tablePage_main_table_body_small"
        >
            {displayedTime}
            {mostRecentTimestamp && 
                <div
                    //className="timestamp_color_code"
                    //title={`mostRecentTimestamp = ${mostRecentTimestamp}`}
                    style={{
                        height: "0.7em",
                        width: "0.7em",
                        borderRadius: "0.35em",
                        // Use shell-yellow? #fbce07
                        backgroundColor: timeSinceLastData < 3 ? "green" : timeSinceLastData < 12 ? "yellow" : "red",
                        display: "inline-block",
                        marginLeft: displayedTime ? "5px" : "40px"
                    }}
                />    
            }
        </td>
    );
}